import { render, staticRenderFns } from "./numbox.vue?vue&type=template&id=230c7ff6"
import script from "./numbox.vue?vue&type=script&lang=js"
export * from "./numbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports